module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/273.ddbfc62f.png";